import { useEffect, useState } from "react";

import FormControlLabel, {
  FormControlLabelProps,
} from "@mui/material/FormControlLabel";

import { SelectCard } from "@covertree/ui/content";
import { useRadioGroup } from "@mui/material/RadioGroup";

interface LossLocationControlLabelProps extends FormControlLabelProps {
  image: string;
  tooltip: string;
  hasError?: boolean;
}

export const LossLocationControlLabel = ({
  label,
  control,
  image,
  tooltip,
  hasError,
  ...props
}: LossLocationControlLabelProps) => {
  const radioGroup = useRadioGroup();

  const [checked, setChecked] = useState(false);
  useEffect(() => {
    if (radioGroup) {
      setChecked(radioGroup.value === props.value);
    }
  }, [radioGroup]);

  return (
    <FormControlLabel
      sx={(theme) => ({
        width: "100%",
        marginRight: 0,
        "& .MuiFormControlLabel-label": {
          width: "100%",
        },
        "&:not(:nth-last-child(1))": {
          marginBottom: theme.spacing(3),
        },
      })}
      control={control}
      {...props}
      label={
        <SelectCard
          selected={checked}
          title={label as string}
          image={image}
          hasError={hasError}
          tooltip={tooltip}
        />
      }
    />
  );
};
